import { createAction, props } from '@ngrx/store';

export const ClearStoreOnLogout = createAction(
  '[App] Clear store on logout'
);
